import { render, staticRenderFns } from "./StockProduction.vue?vue&type=template&id=6a54e5bd&scoped=true&"
import script from "./StockProduction.vue?vue&type=script&lang=js&"
export * from "./StockProduction.vue?vue&type=script&lang=js&"
import style0 from "./StockProduction.vue?vue&type=style&index=0&id=6a54e5bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54e5bd",
  null
  
)

export default component.exports